
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_2rhyz_1uc8t_99",
  "input": "awsui_input_2rhyz_1uc8t_103",
  "input-readonly": "awsui_input-readonly_2rhyz_1uc8t_153",
  "input-invalid": "awsui_input-invalid_2rhyz_1uc8t_220",
  "input-has-icon-left": "awsui_input-has-icon-left_2rhyz_1uc8t_231",
  "input-warning": "awsui_input-warning_2rhyz_1uc8t_236",
  "input-type-search": "awsui_input-type-search_2rhyz_1uc8t_252",
  "input-has-icon-right": "awsui_input-has-icon-right_2rhyz_1uc8t_268",
  "input-has-no-border-radius": "awsui_input-has-no-border-radius_2rhyz_1uc8t_271",
  "input-container": "awsui_input-container_2rhyz_1uc8t_278",
  "input-icon-left": "awsui_input-icon-left_2rhyz_1uc8t_283",
  "input-icon-right": "awsui_input-icon-right_2rhyz_1uc8t_290",
  "input-button-right": "awsui_input-button-right_2rhyz_1uc8t_296"
};
  